import React from 'react';
import { partnerBrands, textBrands } from '../data/site';
export function Brands() {
  return <section aria-labelledby="brands-title" className="gutter w-full border-t border-navy/10 bg-white py-14 md:py-20" data-id="element-23" data-mp="23cv9vjifquzq">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,22rem)_1fr] lg:items-center lg:gap-[5vw]" data-id="element-24" data-mp="2i083zwmb691q">
        <div data-id="element-25" data-mp="2d3hlz3qy13do">
          <h2 id="brands-title" className="display text-4xl font-extrabold text-navy md:text-5xl" data-id="element-26" data-mp="2d2onsr61vm75">
            Parts &amp; Brands We Carry
          </h2>
          <p className="mt-3 text-ink-muted" data-id="element-27" data-mp="1ke0woeyme2lo">
            Also:{' '}
            {textBrands.map((b, i) => <React.Fragment key={b} data-id="element-28" data-mp="1ydiq57mv241d" data-mpi={i}>
                <a href="#contact" className="font-semibold text-navy underline underline-offset-4 hover:text-water-600" data-id="element-29" data-mp="1yelhths0caic">
                  {b}
                </a>
                {i < textBrands.length - 1 && ' · '}
              </React.Fragment>)}
          </p>
        </div>
        <ul className="grid grid-cols-2 items-center gap-x-8 gap-y-10 sm:grid-cols-3 lg:grid-cols-5" data-id="element-30" data-mp="35qap1srt2equ">
          {partnerBrands.map(b => <li key={b.name} className="flex justify-center" data-id="element-31" data-mp="25ue47hmm1mc7">
              <img src={b.src} alt={`${b.name} logo`} loading="lazy" className="h-12 w-auto max-w-[160px] object-contain opacity-70 grayscale transition-[filter,opacity] duration-200 ease-out hover:opacity-100 hover:grayscale-0 md:h-14" data-id="element-32" data-mp="25skt9q4ysfye" />
            </li>)}
        </ul>
      </div>
    </section>;
}